import { defaultLocale, ILocale } from '@/config/locales';

export default function reducer(state: ILocale = defaultLocale) {
  return state;
}
